import { FC, useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../redux/store";
import Card from "../UI/card/card.component";
import {
  BackButtonContainer,
  ButtonColumnContainer,
  GreenHeader,
  GreenP,
  RedHeader,
  SpreadApartArea,
  TextDivider,
} from "../../global.styles";
import {
  BookingType,
  QuoteRequestType,
} from "../../redux/bookings/bookings.types";
import QuoteDetails from "./quote-details";
import Button from "../UI/button/button.component";
import ConfirmBookingForm from "./confirm-booking-form.component";
import {
  clearBookingsError,
  clearNewBookingFlag,
} from "../../redux/bookings/bookings.slice";
import { deleteDoc, doc } from "firebase/firestore";
import { firestore } from "../../firebase/config";
import Modal from "../UI/modal/modal.component";
import Spinner from "../UI/spinner/spinner.component";

// type BookingFormProps = {
//   guoteRequest: QuoteRequestType;
//   quote: BookingType;
// };

const BookingForm: FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [quoteConfirmed, setQuoteConfirmed] = useState(false);
  //modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loadingQuoteDelete, setLoadingQuoteDelete] = useState(false);
  const [errorQuoteDelete, setErrorQuoteDelete] = useState("");

  const { bookingCreated } = useSelector((state: RootState) => state.bookings);
  const { currentUser } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (bookingCreated) {
      setQuoteConfirmed(false);
    }
  }, [bookingCreated]);

  if (
    location.state === null ||
    !location.state.quoteRequest ||
    !location.state.quote
  )
    return <Navigate to="/bookings/quote-form" replace />;

  const quoteRequest = location.state.quoteRequest as QuoteRequestType;
  const quote = location.state.quote as BookingType;
  const actionRequired = location.state.actionRequired ? true : false;

  const clearNewBookingNotification = () => {
    dispatch(clearNewBookingFlag());
    navigate("/bookings");
  };

  const deletequoteHandler = () => {
    setOpenDeleteModal(true);
  };
  const deleteQuoteConfirm = async () => {
    // delete quote
    const quoteRef = doc(
      firestore,
      "users",
      currentUser!.id,
      "quotes",
      "recentQuote"
    );
    try {
      setLoadingQuoteDelete(true);
      await deleteDoc(quoteRef);
      navigate("/bookings/quote-form");
    } catch (error) {
      setErrorQuoteDelete("Error deleting quote");
    } finally {
      setLoadingQuoteDelete(false);
      setOpenDeleteModal(false);
    }
  };
  if (loadingQuoteDelete) return <Spinner />;
  return (
    <Card>
      {!quoteConfirmed && !bookingCreated ? (
        <>
          {openDeleteModal && (
            <Modal
              title="Delete Quote"
              body="Are you sure you want to delete this quote?"
              confirmButtonText="Delete"
              setOpenModal={setOpenDeleteModal}
              onModalConfirm={deleteQuoteConfirm}
            />
          )}
          {loadingQuoteDelete && <Spinner />}
          {errorQuoteDelete && <RedHeader>{errorQuoteDelete}</RedHeader>}

          <BackButtonContainer>
            <Link to="/bookings/quote-form" state={{ quoteRequest }}>
              <h3>Edit Booking</h3>
            </Link>
          </BackButtonContainer>
          <QuoteDetails quote={quote} actionRequired={actionRequired} />
          <TextDivider>
            <GreenP> CONFIRM </GreenP>
          </TextDivider>
          <GreenHeader>Are details above correct?</GreenHeader>
          <SpreadApartArea>
            <Link to="/bookings/quote-form" state={{ quoteRequest }}>
              <Button buttonType="inverted">No, Edit Booking</Button>
            </Link>
            <Button
              onClick={() => {
                dispatch(clearBookingsError());
                setQuoteConfirmed(true);
              }}
            >
              Yes, Continue
            </Button>
          </SpreadApartArea>
          <TextDivider>
            <GreenP> DELETE </GreenP>
          </TextDivider>
          <ButtonColumnContainer>
            <Button buttonType="warning" onClick={deletequoteHandler}>
              Delete Quote
            </Button>
          </ButtonColumnContainer>
        </>
      ) : quoteConfirmed && !bookingCreated ? (
        <>
          <BackButtonContainer>
            <h3 onClick={() => setQuoteConfirmed(false)}>Go Back</h3>
          </BackButtonContainer>
          <ConfirmBookingForm quote={quote} />
        </>
      ) : (
        <>
          <GreenHeader>Booking created!</GreenHeader>
          <GreenP>
            As soon as it gets accepted by Driver, we will let you know.
          </GreenP>
          <BackButtonContainer>
            <Button buttonType="green" onClick={clearNewBookingNotification}>
              Ok
            </Button>
          </BackButtonContainer>
        </>
      )}
    </Card>
  );
};

export default BookingForm;
